import { render, staticRenderFns } from "./applyBox.vue?vue&type=template&id=1965d9e6&scoped=true&"
import script from "./applyBox.vue?vue&type=script&lang=js&"
export * from "./applyBox.vue?vue&type=script&lang=js&"
import style0 from "./applyBox.vue?vue&type=style&index=0&id=1965d9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965d9e6",
  null
  
)

export default component.exports